/* global axios */
import ApiClient from '../ApiClient';

export const buildCreatePayload = ({
  message,
  isPrivate,
  contentAttributes,
  echoId,
  clientRequestId,
  files,
  ccEmails = '',
  bccEmails = '',
  toEmails = '',
  templateParams,
  isSimpleText = false,
  content_type,
  sourceDraftId,
}) => {
  let payload;
  if (files && files.length !== 0) {
    payload = new FormData();
    // Per messaggi con allegati, alcuni canali richiedono comunque la chiave 'content'.
    // Usiamo uno zero-width non-joiner quando il testo è vuoto, per soddisfare sia BE che provider.
    const needsPlaceholder =
      !message || (typeof message === 'string' && message.trim() === '');
    const contentValue = needsPlaceholder ? '\u200C' : message;
    payload.append('content', contentValue);
    files.forEach((file) => {
      payload.append('attachments[]', file);
    });
    payload.append('private', isPrivate);
    payload.append('echo_id', echoId);
    if (clientRequestId) {
      payload.append('client_request_id', clientRequestId);
    }
    payload.append('cc_emails', ccEmails);
    payload.append('bcc_emails', bccEmails);

    if (toEmails) {
      payload.append('to_emails', toEmails);
    }
    if (contentAttributes && !isSimpleText) {
      payload.append('content_attributes', JSON.stringify(contentAttributes));
    }
    if (content_type) {
      payload.append('content_type', content_type);
    }
    if (sourceDraftId) {
      payload.append('source_draft_id', sourceDraftId);
    }
  } else {
    payload = {
      content: message,
      private: isPrivate,
      echo_id: echoId,
      cc_emails: ccEmails,
      bcc_emails: bccEmails,
      to_emails: toEmails,
      template_params: templateParams,
    };

    if (clientRequestId) {
      payload.client_request_id = clientRequestId;
    }

    // Aggiungiamo content_type se specificato
    if (content_type) {
      payload.content_type = content_type;
    }

    // Aggiungiamo content_attributes solo se non è un messaggio semplice
    if (contentAttributes && !isSimpleText) {
      payload.content_attributes = contentAttributes;
    }

    // Bozza AI da cui è partita la risposta: è solo un indizio, il server
    // lo verifica sulla conversazione (Messages::DraftOriginResolver).
    if (sourceDraftId) {
      payload.source_draft_id = sourceDraftId;
    }
  }
  return payload;
};

class MessageApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  create({
    conversationId,
    message,
    private: isPrivate,
    contentAttributes,
    echo_id: echoId,
    client_request_id: clientRequestId,
    files,
    ccEmails = '',
    bccEmails = '',
    toEmails = '',
    templateParams,
    content_type,
    sourceDraftId,
  }) {
    return axios({
      method: 'post',
      url: `${this.url}/${conversationId}/messages`,
      data: buildCreatePayload({
        message,
        isPrivate,
        contentAttributes,
        echoId,
        clientRequestId,
        files,
        ccEmails,
        bccEmails,
        toEmails,
        templateParams,
        content_type,
        sourceDraftId,
      }),
    });
  }

  delete(conversationID, messageId) {
    return axios.delete(`${this.url}/${conversationID}/messages/${messageId}`);
  }

  retry(conversationID, messageId) {
    return axios.post(
      `${this.url}/${conversationID}/messages/${messageId}/retry`
    );
  }

  getPreviousMessages({ conversationId, after, before }, options = {}) {
    const params = { before };
    if (
      after !== null &&
      after !== undefined &&
      after !== '' &&
      Number(after) !== Number(before)
    ) {
      params.after = after;
    }
    const config = { params };
    if (options.signal) {
      config.signal = options.signal;
    }
    const messagesUrl =
      options.accountId === null || options.accountId === undefined
        ? this.url
        : `${this.apiVersion}/accounts/${encodeURIComponent(
            String(options.accountId)
          )}/${this.resource}`;
    return axios.get(`${messagesUrl}/${conversationId}/messages`, config);
  }

  // Invia una reaction emoji a un messaggio (solo WhatsApp)
  sendReaction(conversationId, messageId, emoji) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/react`,
      { emoji }
    );
  }
}

export default new MessageApi();
